import {Injectable} from '@angular/core';
import {clear, del, get, set} from 'idb-keyval';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  public readValueFromSessionStorage(key: string): string | null {
    if (typeof (sessionStorage) !== 'undefined') {
      const item = sessionStorage.getItem(key);
      return this.validateAngGetObject(item);
    } else {
      console.warn('No session storage support available for this browser');
    }
    return null;
  }


  readValueFromLocalStorage(key: string): string | null {
    if (typeof (Storage) !== 'undefined') {
      const item = localStorage.getItem(key);
      return this.validateAngGetObject(item);
    } else {
      console.warn('No local storage support available for this browser');
    }
    return null;
  }

  private validateAngGetObject(item: string | null): any | null {
    if (item == null || item.length == 0) {
      return null;
    }
    return JSON.parse(item);
  }

  deleteByKeyFromSessionStorage(key: string): void {
    if (typeof (sessionStorage) !== 'undefined') {
      sessionStorage.removeItem(key);
    } else {
      console.warn('No session storage support available for this browser');
    }
  }

  writeValueToSessionStorage(key: string, value: any): void {
    if (typeof (sessionStorage) !== 'undefined') {
      sessionStorage.setItem(key, JSON.stringify(value));
    } else {
      console.warn('No session storage support available for this browser');
    }
  }

  deleteByKeyFromLocalStorage(key: string): void {
    if (typeof (Storage) !== 'undefined') {
      localStorage.removeItem(key);
    } else {
      console.warn('No local storage support available for this browser');
    }
  }

  writeValueToLocalStorage(key: string, value: any): void {
    // to local storage
    if (typeof (Storage) !== 'undefined') {
      try {
        localStorage.setItem(key, JSON.stringify(value));
      } catch (e) {
        console.error('Error writing key ' + key + ' in local storage', e);
      }
    } else {
      console.warn('No local storage support available for this browser');
    }
  }

  readValueFromIndexedDb<T>(key: string): Promise<T | undefined> {
    return get<T>(key);
  }

  writeValueToIndexedDb(key: string, value: any): Promise<void> {
    const promise = set(key, JSON.stringify(value));

    promise.then(() => console.log('Key ' + key + ' written in indexedDb'))
    .catch((err) => console.error('Error writing key ' + key + ' in indexedDb', err));

    return promise;
  }

  deleteByKeyFromIndexDb(key: string): void {
    const deletePromise = del(key);
    deletePromise.then(() => console.log('Key ' + key + ' deleted from indexedDb'))
    .catch((err) => console.error('Error deleting key ' + key + ' in indexedDb', err));
  }

  public clearSessionStorage(): void {
    if (typeof (sessionStorage) !== 'undefined') {
      sessionStorage.clear();
    }
  }

  public clearLocalStorage(): void {
    if (typeof (Storage) !== 'undefined') {
      localStorage.clear();
    }
  }

  public clearIndexedDb(): void {
    clear().then();
  }

  public clearStorage(): void {
    this.clearSessionStorage();
    this.clearLocalStorage();
    this.clearIndexedDb();
  }

}
